'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pubsub = require('../events/pubsub.js');
var index = require('../events/index.js');
var index$1 = require('../storage/index.js');
var http = require('./http.js');
var ws = require('./ws.js');

(function(TransportType2) {
  TransportType2["HTTP"] = "HTTP";
  TransportType2["BOTH"] = "BOTH";
})(exports.TransportType || (exports.TransportType = {}));
const platformRegex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i;
const deviceRegex = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
const LAST_ACTIVITY_KEY = "last-req";
const DEFAULT_RECONNECTION_DELAY = 1e3;
const MAX_RECONNECTION_DELAY = 2e4;
class Transport {
  constructor() {
    this.cdnUrl = "";
    this.recordActivity = false;
    this.reconnectionDelay = DEFAULT_RECONNECTION_DELAY;
  }
  setup(opts) {
    if (!opts.httpUrl) {
      throw new Error("httpUrl params is mandatory");
    }
    this.cdnUrl = opts.cdnUrl;
    this.recordActivity = opts.recordLastActivity || false;
    if (opts.desktopDevice === void 0) {
      if (typeof window === "undefined") {
        opts.desktopDevice = false;
      } else {
        opts.desktopDevice = !this.isMobileOrTablet(navigator.userAgent || navigator.vendor);
      }
    }
    this.httpDriver = new http.Http(this.normaliseUrl(opts.httpUrl), opts.brand, opts.key, opts.httpDriver);
    this.driver = this.httpDriver;
    if (opts.transport === exports.TransportType.HTTP) {
      return Promise.resolve();
    }
    if (!opts.wsUrl) {
      throw new Error('The selected transport type "BOTH" requires value for the "wsUrl" property');
    }
    this.wsDriver = new ws.WS(this.normaliseUrl(opts.wsUrl), opts.key, opts.desktopDevice, opts.wsDriver);
    if (opts.wsReconnect) {
      index.events.wsDisconnected(() => this.reconnect());
      index.events.wsConnected(() => this.reconnectionDelay = DEFAULT_RECONNECTION_DELAY);
    }
    return this.wsDriver.connect();
  }
  destroy() {
  }
  getDriver() {
    if (this.httpDriver === void 0) {
      throw new Error('You have to setup the sdk first by calling the "setup" method');
    }
    return this.httpDriver;
  }
  getCDNUrl() {
    return this.cdnUrl;
  }
  getHttpDriver() {
    if (this.httpDriver === void 0) {
      throw new Error("Http driver is not set");
    }
    return this.httpDriver;
  }
  request(endpoint, params) {
    if (this.recordActivity) {
      setTimeout(() => index$1.storage.setItem(LAST_ACTIVITY_KEY, new Date().getTime()));
    }
    return this.getDriver().request(endpoint, params).catch((error) => {
      this.handleRequestError(error);
      throw error;
    });
  }
  handleRequestError(error) {
    const message = error instanceof Error ? error.message : error || "";
    if (message.includes("SOWQ_REQUESTED")) {
      pubsub.pubsub.publish(pubsub.Topic.SOWQRequested);
    }
  }
  subscribe(params) {
    if (this.wsDriver === void 0) {
      return Promise.resolve();
    }
    return this.wsDriver.request("/pubsub/subscribe", params);
  }
  unsubscribe(params) {
    if (this.wsDriver === void 0) {
      return Promise.resolve();
    }
    return this.wsDriver.request("/pubsub/unsubscribe", params);
  }
  getLastTimestamp() {
    return index$1.storage.getItem(LAST_ACTIVITY_KEY);
  }
  uploadFiles(endpoint, files, onProgressChange, params) {
    return this.getHttpDriver().upload(endpoint, files, onProgressChange, params);
  }
  isMobileOrTablet(platform) {
    if (platformRegex.test(platform) || deviceRegex.test(platform.substr(0, 4))) {
      return true;
    }
    return false;
  }
  reconnect() {
    this.reconnectionDelay = Math.min(this.reconnectionDelay, MAX_RECONNECTION_DELAY);
    setTimeout(() => {
      if (this.wsDriver instanceof ws.WS) {
        this.wsDriver.connect();
      }
    }, this.reconnectionDelay);
    this.reconnectionDelay <<= 1;
  }
  normaliseUrl(url) {
    if (url.endsWith("/")) {
      return url.substring(0, url.length - 1);
    }
    return url;
  }
}
const transport = new Transport();

exports.transport = transport;
